import {
  __objRest,
  __spreadValues
} from "./chunk-BBZEL7EG.js";

// src/GainsTypography/GainsTypography.tsx
import Typography from "@mui/joy/Typography";
import { styled, useThemeProps } from "@mui/joy/styles";
import useSlot from "@mui/joy/utils/useSlot";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var name = "LevanaGainsTypography";
var GainsTypographyRoot = styled(Typography, {
  name,
  slot: "root"
})({});
var GainsTypography = forwardRef(
  function GainsTypography2(inProps, ref) {
    const props = useThemeProps({ props: inProps, name });
    const otherProps = __objRest(props, []);
    const _a = props, { gains } = _a, externalForwardedProps = __objRest(_a, ["gains"]);
    const ownerState = __spreadValues({}, otherProps);
    const [SlotRoot, rootProps] = useSlot("root", {
      ref,
      className: "root",
      elementType: GainsTypographyRoot,
      ownerState,
      externalForwardedProps
    });
    return /* @__PURE__ */ jsx(
      SlotRoot,
      __spreadValues({
        color: (() => {
          if (gains) {
            if (gains > 0) {
              return "success";
            } else if (gains < 0) {
              return "danger";
            }
          }
        })()
      }, rootProps)
    );
  }
);
var GainsTypography_default = GainsTypography;

export {
  GainsTypography_default
};
